import { createRoot } from 'react-dom/client';
import App from '@/components/providers/AppProviders/AppProviders';
import { Provider } from 'react-redux';
import { store } from './store/store';
//import { Router } from 'react-router-dom';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <Provider store={store}>
    <App />
  </Provider>,
);
